// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3I6ya","colMin":"styles_colMin__1Y2gD","colCheckbox":"styles_colCheckbox__2EACf"};